// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.0677 7.07007L12 0.0690918L4.93229 7.07007C1.02257 10.9429 1.02257 17.2259 4.93229 21.0987C8.83675 24.9663 15.1632 24.9663 19.0677 21.0987C22.9774 17.2259 22.9774 10.9429 19.0677 7.07007ZM18 13.9963C18 17.31 15.3137 19.9963 12 19.9963V7.99634C15.3137 7.99634 18 10.6826 18 13.9963Z"}}]};

const SaturationFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'saturation-filled',
    ref,
    icon: element,
  },
));

SaturationFilledIcon.displayName = 'SaturationFilledIcon';

export default SaturationFilledIcon;
